import { render, staticRenderFns } from "./Demographic.vue?vue&type=template&id=5c16a4b8&"
import script from "./Demographic.vue?vue&type=script&lang=js&"
export * from "./Demographic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports